import { Children } from "react";

export const If = ({ condition, children }) => {
  const elseChildren = Children.toArray(children).filter((child) => child.type === Else);
  const ifChildren = Children.toArray(children).filter((child) => child.type !== Else);

  return condition ? <>{ifChildren}</> : <>{elseChildren}</>;
};

export const Else = ({ children }) => children;
